import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full font-sans text-text-light bg-dark-100 selection:bg-accent selection:text-dark-100" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MethodSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <AudienceSection data-id="element-6" />
      <HowItWorksSection data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}